import CompanyQuotePersonProfile from './CompanyQuotePersonProfile'
export { CompanyQuotePersonProfile }
export default CompanyQuotePersonProfile
